import { FunctionComponent } from 'react';
import { FormConditionalField } from './FormConditionalField';
import StaticConditionalField from './StaticConditionalField';
import { usePageType } from '../../../core/contexte/PageTypeContext';
import {
  ConditionalFieldProps,
  FormConditionalFieldProps,
  StaticConditionalFieldProps,
} from './types';

const ConditionalField: FunctionComponent<ConditionalFieldProps> = (props) => {
  const { isStaticPage } = usePageType();

  if (!isStaticPage) {
    return <FormConditionalField {...(props as FormConditionalFieldProps)} />;
  }

  return <StaticConditionalField {...(props as StaticConditionalFieldProps)} />;
};

export default ConditionalField;
